<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 11:12:37
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div :class="[isFlatThree?'Three-Screennursing-one':'','nursing-one']">
  <!-- <div class="nursing-one" @click.capture="nursingCapture"> -->
    <transition name="head">
      <div v-if="!isFlatThreeFullScreen" class="head">
        <filterBtn @click="openFilter(true)"></filterBtn>
        <el-input
          class="search"
          placeholder="搜索长者"
          v-model="search">
          <el-image
          class="search-image"
          slot="prefix"
          :src="sousuo"
          fit="contain"></el-image>
        </el-input>
      </div>
    </transition>
    <div v-if="!isFlatThree" class='nursingItem-list'>
      <template v-if="elderlyCaresList&&elderlyCaresList.length">
        <div @click="goImplement(item.Id)" class="nursingItem-container" v-for="item in elderlyCaresList" :key="item.Id">
          <nursingItem :Name="item.Name" :ImgUrl="item.ImgUrl" :NotExecuted="item.NotExecuted" :TotalCare="item.TotalCare" :Room="item.Room"
          :Id="item.Id" :CareLevel="item.CareLevel" @goPhoto="goPhoto"></nursingItem>
        </div>
      </template>
      <tips v-else></tips>
    </div>

    <div v-else :class="[isFullScreen?'three-list-FullScreen':'','three-list']">
      <div v-if="isFullScreen" class="three-title">长者护理</div>
      <div v-if="elderlyCaresList&&elderlyCaresList.length" :class="[isFullScreen?'three-item-list-FullScreen':'','three-item-list']">
        <div class="three-item" @click="goImplement(item.Id)" v-for="item in elderlyCaresList" :key="item.Id">
          <div class="three-item-top">
            <el-image
            class="three-nursing-image"
            fit="cover"
            :src="item.ImgUrl||avatar"></el-image>
            <div class="three-name-level">
              <div>
                <div class="three-name">{{item.Name}}</div>
                <div class="three-level">test{{item.CareLevel}}</div>
              </div>
              <div>
                <div class="three-room">
                  <span>房号：</span>
                  <span>{{item.Room}}</span>
                </div>
                <el-image
                class="photo"
                fit="cover"
                @click.stop="goPhoto(item.Id)"
                :src="photo"></el-image>
              </div>
            </div>
          </div>
          <div class="three-other">
            <div class="three-other-item three-other-TotalCare">
              <div class="three-other-text">护理项目</div>
              <div class="three-num">
                <div class="three-num-span">{{item.TotalCare>99?'99+':item.TotalCare}}</div>
              </div>
            </div>
            <div class="three-other-item three-other-NotExecuted">
              <div class="three-other-text">待执行</div>
              <div class="three-num">
                <div class="three-num-span">{{item.NotExecuted>99?'99+':item.NotExecuted}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else :class="[isFullScreen?'tips-container':'']">
        <tips></tips>
      </div>
    </div>
    <pager v-if="!isFlatThree" @changePage="changePage" @changeSize="changeSize" :page='page+1' :total="total" :size="size"></pager>
  </div>
</template>

<script>
import nursingItem from '@/common/nursing-item.vue'
import filterBtn from '@/common/filter-btn.vue'
import pager from '@/common/pager.vue'
import tips from '@/common/tips.vue'
import {group} from '@/tool'
import { mapState,mapGetters,mapMutations,mapActions } from 'vuex'

import photo from "@/assets/imgs/photo.png";
import avatar from "@/assets/imgs/avatar.png";
import sousuo from "@/assets/imgs/icon-sousuo-32@2x.png";
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    nursingItem,
    filterBtn,
    pager,
    tips
  },
  // 组件状态值
  data () {
   return {
     search:"",
     size:10,
     page:0,
     total:10,
     photo,
     avatar,
     sousuo
   }
  },
  // 计算属性
  computed: {
    ...mapState(['ElderlyCares','isFullScreen','timer','isFullScreen']),
    ...mapState('filter',['selectRooms']),
    ...mapGetters(['isFlatThreeFullScreen','isFlatThree']),
    filtersElderlyCares(){
      let arr=this.ElderlyCares.filter(item=>{
        return (!this.selectRooms.length||this.selectRooms.indexOf(item.Room)!=-1)&&(!this.search||item.Name.indexOf(this.search)!=-1)
      })
      this.total=arr.length
      if(this.page*this.size>=this.total){
        this.page=0
      }
      arr=group(arr,this.size)
      return arr||[[]]
    },
    elderlyCaresList(){
      return this.filtersElderlyCares[this.page]
    },

  },
  // 侦听器
  watch: {
    elderlyCaresList:{
      handler: function(val){
        this.updateThree(val&&val.length<4 )
      },
      immediate:true
    }
  },
  // 组件方法
  methods: {
    ...mapMutations(['resetTime','updateThree']),
    ...mapActions('filter', ['openFilter']),
    goImplement(Id){
      this.$router.push({
        name:"nursingOneImplement",
        query: { Id }
      })
    },
    changeSize(size){
      this.size=size
    },
    changePage(page){
      this.page=page
    },
    goPhoto(Id){
      this.$router.push({
        name:'photo',
        query: { Id }
      })
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
    this.$store.commit('setScanCode','')
    this.resetTime()
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script>

<style scoped>


.nursing-one{
  margin: 0px ;
  padding-bottom: 60px;
}
.head{
  position: fixed;
  top: 89px;
  left: 0px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  z-index: 1;
}
/* .head::after{
  position: absolute;
  width: 80%;
} */

.search-image{
  width: 16px;
  height: 16px;
  margin: 9px 4px 10px 10px;
}
.search,.head >>> .el-input__inner{
  width: 274px;
  height: 35px;
  font-size: 12px;
  background: #F4F4F4;
  border:1px solid #F4F4F4;
}
.search{
  font-size: 14px;
}
.head >>> .el-input--prefix .el-input__inner{
  padding-left: 32px;
}
.nursingItem-container{
  margin: 12px 0px;
  background: #fff;
  border-radius: 4px;
}
.nursingItem-list{
  padding: 111px 15px 0px 15px;
}



.Three-Screennursing-one{
  padding-bottom: 0px;
}
.title{
  text-align: center;
  margin: 54px 0px 27px 0px;
  font-size: 18px;
  color: #FFFFFF;
}
.three-list{
   padding: 111px 15px 0px 15px;
}
.three-list-FullScreen{
  padding-top: 1px;
  background: url('../../assets/imgs/bg.png');
  background-size: 375px 44px;
  background-repeat: no-repeat;
}
.three-title{
  text-align: center;
  margin: 10px 0px;
  font-size: 18px;
  color: #FFFFFF;
}
.three-item-list{
  display: flex;
  flex-direction: column;
}
.three-item-list-FullScreen{
  /* height: calc(100vh - 90px); */
  min-height: calc(100vh - 46px );

}
.three-item{
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 345px;
  justify-content: center;
  /* height: 322px; */
  /* max-height: calc((100vh - 160px) / 3 ); */
  max-height: calc((100vh - 80px) / 3 );
  background: #FFFFFF;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
  border-radius: 16px;
  padding: 15px;
  /* margin: 30px 0px; */
  margin: 5px 0px;
  box-sizing: border-box;
}
.three-item-top{
  display: flex;
  align-items: center;
}
.three-nursing-image{
  /* width: 148px;
  height: 148px;
  border-radius: 74px; */
  width: 60px;
  height: 60px;
  border-radius: 30px;
  border: 1px solid #029FD1;
  overflow: hidden;
}
.three-name-level{
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 8px;
}
.three-name{
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 4px;
  color: #0A0E10;
}
.three-level{
  font-size: 12px;
  color: #7C7E80;
}
.three-room{
  font-size: 12px;
  color: #029FD1;
  font-weight: bold;
}
.photo{
   width: 22px;
   height:22px;
   margin-top: 8px;
   margin-left: -3px;
}
.three-other{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  text-align: center;
  line-height: 32px;
}
.three-other-item{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 32px;;
  border-radius: 2px;
  font-size: 14px;
}
.three-other-text{
  font-weight: 500;
}
.three-other-TotalCare{
  background: #DEF7FF;
  color: #029FD1;
}
.three-other-NotExecuted{
  background: #FEF3E7;
  color: #885218;
}
.three-num{
  position: relative;
  width: 16px;
  height: 16px;
  background: #F22D2E;
  border-radius: 50%;
  color: #fff;
  line-height: 16px;
  margin-left: 4px;
}
.three-num-span{
  /* font-size: 20px; */
  font-size: 17px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) scale(0.5,0.5);
}
.tips-container{
  padding-top: 67px;
}

</style>



// WEBPACK FOOTER //
// src/components/nursing/nursing-one.vue